import { useContext } from 'react';
import MainContext from '../context/mainContext';

const useMain = () => useContext(MainContext);
export default useMain;
